const LABELS = {
  NeverRun: "Not matched yet",
  Calculating: "Calculating…",
  Completed: "Matched",
  Failed: "Match failed",
};

/**
 * Shows match-run state so a stale count is never mistaken for a fresh one.
 */
export default function MatchStatusPill({ status, asOfUtc }) {
  const key = status || "NeverRun";
  const label = LABELS[key] || key;
  const title = asOfUtc ? `Last completed ${new Date(asOfUtc).toLocaleString()}` : undefined;

  return (
    <span className={`matchStatusPill matchStatusPill--${key.toLowerCase()}`} title={title}>
      {label}
    </span>
  );
}
